module.exports = __webpack_public_path__ + "images/icons/icon-locked-3a9b96b1.svg";